import script from "./QuickAmountPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./QuickAmountPicker.vue?vue&type=script&setup=true&lang=js"

import "./QuickAmountPicker.vue?vue&type=style&index=0&id=6abaf34a&scoped=true&lang=less"

import exportComponent from "/data/web/pay/brpay/brpay-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6abaf34a"]])

export default __exports__